import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import AdCard from "../../components/common/AdCard";
import { getAdsForSection } from "../../config/ads";

// Country data configuration
const COUNTRIES = [
  {
    name: "India",
    flag:
      "https://upload.wikimedia.org/wikipedia/en/thumb/4/41/Flag_of_India.svg/1200px-Flag_of_India.svg.png",
    route: "/immigration/India",
    region: "Asia",
  },
  {
    name: "USA",
    flag:
      "https://cdn.britannica.com/33/4833-050-F6E415FE/Flag-United-States-of-America.jpg",
    route: "/immigration/usa",
    region: "North America",
  },
  {
    name: "Japan",
    flag:
      "https://upload.wikimedia.org/wikipedia/en/thumb/9/9e/Flag_of_Japan.svg/1200px-Flag_of_Japan.svg.png",
    route: "/immigration/japan",
    region: "Asia",
  },
  {
    name: "Australia",
    flag:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/88/Flag_of_Australia_%28converted%29.svg/800px-Flag_of_Australia_%28converted%29.svg.png",
    route: "/immigration/australia",
    region: "Oceania",
  },
  {
    name: "United Kingdom",
    flag:
      "https://upload.wikimedia.org/wikipedia/en/a/ae/Flag_of_the_United_Kingdom.svg",
    route: "/immigration/uk",
    region: "Europe",
  },
  {
    name: "Canada",
    flag:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/Flag_of_Canada_%28Pantone%29.svg/800px-Flag_of_Canada_%28Pantone%29.svg.png",
    route: "/immigration/canada",
    region: "North America",
  },
  {
    name: "Germany",
    flag:
      "https://upload.wikimedia.org/wikipedia/en/thumb/b/ba/Flag_of_Germany.svg/1200px-Flag_of_Germany.svg.png",
    route: "/immigration/germany",
    region: "Europe",
  },
  {
    name: "Sweden",
    flag: "https://upload.wikimedia.org/wikipedia/en/4/4c/Flag_of_Sweden.svg",
    route: "/immigration/sweden",
    region: "Europe",
  },
  {
    name: "New Zealand",
    flag:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTyaMYVM3TLnLYb-vsiLznwq7XEse8rh0qOs9okmGyYJdbqDDk_W3Qc4Gmx9vw8&s=10",
    route: "/immigration/NewZealand",
    region: "Oceania",
  },
  {
    name: "Netherlands",
    flag:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR-cMRZC5C541STWUJheF8YljaAh1EGUocuGEKGY_Qd_28qlemkuV1a6hzZp2rQ&s=10",
    route: "/immigration/Netherlands",
    region: "Europe",
  },
  {
    name: "Switzerland",
    flag:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRUrW1Fv12iPVXb0L2XUFa4jrsGU2SzvpGwew&s",
    route: "/immigration/Switzerland",
    region: "Europe",
  },
  {
    name: "South Africa",
    flag:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/af/Flag_of_South_Africa.svg/250px-Flag_of_South_Africa.svg.png",
    route: "/immigration/south-africa",
    region: "Africa",
  },
  {
    name: "Thailand",
    flag:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Flag_of_Thailand.svg/1200px-Flag_of_Thailand.svg.png",
    route: "/immigration/thailand",
    region: "Asia",
  },
  {
    name: "South Korea",
    flag:
      "https://www.lallemandpharma.com/wp-content/uploads/2017/12/225px-Flag_of_South_Korea.svg_.png",
    route: "/immigration/south-korea",
    region: "Asia",
  },
];

// Country Card Component (wrapper for grid)
const CountryCard = ({ country }) => (
  <Col xs={6} md={4} lg={3}>
    <CountryCardContent country={country} />
  </Col>
);

// Country Card Content (reusable)
const CountryCardContent = ({ country }) => (
  <NavLink to={country.route} className="text-decoration-none">
    <div className="country-card">
      <img
        src={country.flag}
        alt={`${country.name} flag`}
        className="country-flag"
      />
      <h6 className="country-name">{country.name}</h6>
    </div>
  </NavLink>
);

// Main Immigration Component
const ImmCountry = () => {
  // Get ads for immigration section (returns {ad1, ad2})
  const { ad1, ad2, ad3 } = getAdsForSection("Immigration");

  return (
    <div className="imm-country-container">
      <Container fluid className="px-4 py-4">
        {/* Header Section */}
        <Row>
          <Col xs={12} className="mb-4">
            <h4 className="section-title">Immigration Policies by Country</h4>
          </Col>
        </Row>

        <Row>
          {/* Countries Grid - Left Side */}
          <Col lg={9} md={8} xs={12}>
            <div className="immigration-grid">
              {COUNTRIES.map((country, index) => (
                <div key={index}>
                  <CountryCardContent country={country} />
                </div>
              ))}
            </div>
          </Col>

          {/* Advertisement - Right Side */}
          <Col lg={3} md={4} xs={12} className="ad-sidebar">
            {ad3 && <AdCard ad={ad3} />}
          </Col>
        </Row>
      </Container>

      <style jsx>{`
        .imm-country-container {
          background: #f8f9fa;
          min-height: 90vh;
          padding: 0;
        }

        .section-title {
          font-size: 1.75rem;
          font-weight: 700;
          color: #2c3e50;
          border-bottom: 3px solid #3498db;
          padding-bottom: 12px;
        }

        /* GRID */
        .immigration-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 10px;
        }

        .ad-sidebar {
          position: sticky;
          top: 20px;
          height: fit-content;
        }

        .country-card {
          background: white;
          border-radius: 10px;
          padding: 15px;
          text-align: center;
          transition: all 0.3s ease;
          cursor: pointer;
          height: 100%;
          border: 1px solid #e8e8e8;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
        }

        .country-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 16px rgba(52, 152, 219, 0.2);
          border-color: #3498db;
        }

        .country-flag {
          width: 60px;
          height: 45px;
          object-fit: cover;
          border-radius: 6px;
          margin-bottom: 8px;
          border: 1px solid #e0e0e0;
          transition: transform 0.3s ease;
        }

        .country-card:hover .country-flag {
          transform: scale(1.1);
        }

        .country-name {
          font-size: 15px;
          font-weight: 600;
          color: #2c3e50;
          margin: 0;
        }

        /* ≤1200px */
        @media (max-width: 1200px) {
          .immigration-grid {
            grid-template-columns: repeat(3, 1fr);
          }
        }

        /* ≤768px (tablets) */
        @media (max-width: 768px) {
          .immigration-grid {
            grid-template-columns: repeat(2, 1fr);
          }

          .section-title {
            font-size: 1.5rem;
          }

          .country-card {
            padding: 14px;
          }

          .country-flag {
            width: 50px;
            height: 38px;
          }

          .country-name {
            font-size: 14px;
          }
        }

        /* ≤576px (MOBILE – FIXED TO 2 PER ROW) */
        @media (max-width: 576px) {
          .immigration-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 8px;
          }

          .country-card {
            padding: 12px;
          }

          .country-flag {
            width: 45px;
            height: 34px;
          }

          .country-name {
            font-size: 13px;
          }
        }
      `}</style>
    </div>
  );
};

export default ImmCountry;
